
/**
 * 安全要求将公共涉及安全问题的API公共处理 来代替 esapi
 * @param {string} url 
 * @returns 
 */
export function checkUrl(url){
    if(typeof url === 'string' && url.length<1000){
        let urlReg = new RegExp('^(ht|f)tp(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\:\\\'\\/\\\\\\+=&amp;%\\$#_]*)?$');
        return urlReg.test(url);
    }
    return false;
}